function ConseilSyndical(CS) {
    switch (CS) {
    case 'P':
        return {
            Icone: 'fas fa-chess-king texte-cs',
            Titre: 'Président',
            TitreLong: 'Président du conseil syndical',
        };
    case 'M':
        return { Icone: 'fas fa-users texte-cs', Titre: 'Membre', TitreLong: 'Membre du conseil syndical' };
    default:
        return { Icone: '', Titre: '', TitreLong: '' };
    }
}

export default ConseilSyndical;



// WEBPACK FOOTER //
// ./src/App_Data/ConseilSyndical.js